/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import sysJwt from "../../../utils/sysJwt";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import GridTable from "@nadavshaar/react-grid-table";
import { confirmAlert } from "react-confirm-alert";

class SuppotServices extends Component {
  state = {
    data: {
      clientId: "",
      typeId: "",
      title: "",
      details: "",
      startDate: "",
      endDate: "",
    },

    contentHeader: "Support&Services",
    addButtonLabel: "Add New",
    addButtonIcon: "fa fa-plus",

    dataUrl: "/api/data/GetSupportServices",
    singleItemUrl: "/api/data/GetSupportService",
    addUrl: "/api/data/AddSupportService",
    editUrl: "/api/data/EditSupportService",
    deleteUrl: "/api/data/DeleteSupportService",

    inEditMode: false,
    inModalMode: false,
    modalHeaderAdd: "Add Support&Services",
    modalSubmitButtonLabelAdd: "Add",
    modalSubmitButtonIconAdd: "fa fa-plus",
    modalHeaderEdit: "Edit Support&Services",
    modalSubmitButtonLabelEdit: "Edit",
    modalSubmitButtonIconEdit: "fa fa-edit",
    modalWidth: "70vw",

    editEntityId: 0,

    allTypes: [],
    allClients: [],

    tableData: [],
    tableColumns: [
      {
        id: 1,
        label: "Title",
        field: "TITLE",
      },
      {
        id: 2,
        label: "Type",
        field: "TYPE",
      },
      {
        id: 3,
        label: "Clinet",
        field: "CLIENT",
      },
      {
        id: 4,
        label: "Details",
        field: "DETAILS",
      },
      {
        id: 5,
        label: "Start Date",
        field: "START_DATE",
      },
      {
        id: 6,
        label: "End Date",
        field: "END_DATE",
      },
      {
        id: 7,
        label: "Insert Date",
        field: "INSERT_DATE",
      },
      {
        id: 8,
        label: "Last Update",
        field: "LAST_UPDATE",
      },
      {
        id: 9,
        label: "Actions",
        field: "SYS_ACTINOS",
        width: "100px",
        maxResizeWidth: "100px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => {
          return (
            <div id="outer">
              {sysJwt.isAuthorized(["CB19"]) && (
                <div className="inner" title="Edit">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => {
                      this.getEditFormData(data).then(() => {
                        this.setState({
                          inEditMode: true,
                        });
                        this.showForm();
                      });
                    }}
                  >
                    <i className="fa fa-edit" />
                  </button>
                </div>
              )}
              {sysJwt.isAuthorized(["CB1A"]) && (
                <div className="inner" title="Delete">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => this.handleDelete(data)}
                  >
                    <i className="fa fa-trash" />
                  </button>
                </div>
              )}
              <div className="inner" title="View Files">
                <button
                  className="dropdown-item btn-popup-menu"
                  disabled={this.props.isLoading}
                  onClick={() => {
                    this.handleViewFiles(data);
                  }}
                >
                  <i className="fa fa-files-o" />
                </button>
              </div>
            </div>
          );
        },
      },
    ],
  };

  handleViewFiles(row) {
    window.location.replace(
      "/dashboard/supportservicesfile?supportServiceId=" + row.ID
    );
  }

  handleDelete(row) {
    confirmAlert({
      title: "Delete Support&Services",
      message: "Are you sure to delete this Support&Services?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            post(
              this.state.deleteUrl,
              { supportServiceId: row.ID },
              this.props.updateIsLoading
            ).then((apiResponse) => {
              apiResponse.data.respCode === 0 ? this.getData() : null;
            });
          },
        },
        {
          label: "Cancel",
          onClick: () => null,
        },
      ],
    });
  }

  componentDidMount() {
    this.getData();
    this.getAllTypes();
    this.getAllClients();
  }

  getAllTypes() {
    post(
      "/api/data/GetAllSupportServicesTypesDropdown",
      null,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      this.setState({
        allTypes: apiResponse.data.respData.data,
      });
    });
  }

  getAllClients() {
    post("/api/data/GetClientsDropdown", null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({
          allClients: apiResponse.data.respData.data,
        });
      }
    );
  }

  updateForm = (inputId, inputValue) => {
    var data = this.state.data;
    data[inputId] = inputValue;
    this.setState({ data });
  };

  showForm() {
    this.setState({ inModalMode: true });
  }

  closeModal() {
    var data = this.state.data;

    Object.keys(data).forEach(function (key) {
      Array.isArray(data[key]) ? (data[key] = []) : (data[key] = "");
    });

    this.setState({
      inModalMode: false,
      inEditMode: false,
      data: data,
      editEntityId: 0,
    });

    this.getData();
  }

  getData() {
    post(this.state.dataUrl, null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({ tableData: apiResponse.data.respData.data });
      }
    );
  }

  getEditFormData(row) {
    return post(
      this.state.singleItemUrl,
      { id: row.ID },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      var data = this.state.data;

      data["clientId"] = apiResponse.data.respData.data[0].CLIENT_ID;
      data["typeId"] = apiResponse.data.respData.data[0].TYPE_ID;
      data["title"] = apiResponse.data.respData.data[0].TITLE;
      data["details"] = apiResponse.data.respData.data[0].DETAILS;
      data["startDate"] = apiResponse.data.respData.data[0].START_DATE;
      data["endDate"] = apiResponse.data.respData.data[0].END_DATE;

      this.setState({
        data: data,
        editEntityId: apiResponse.data.respData.data[0].ID,
      });
    });
  }

  doSubmit() {
    const submitData = Object.assign({}, this.state.data);

    if (this.state.inEditMode) {
      submitData["supportServiceId"] = this.state.editEntityId;
    }
    post(
      this.state.inEditMode ? this.state.editUrl : this.state.addUrl,
      submitData,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
      }
    });
  }

  render() {
    return (
      <div className="bms-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{this.state.contentHeader}</h4>
          </div>
          <div className="col flex-container-left">
            {sysJwt.isAuthorized(["CB18"]) && (
              <Button
                label={this.state.addButtonLabel}
                icon={this.state.addButtonIcon}
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => {
                  this.setState({ inEditMode: false });
                  this.showForm();
                }}
              />
            )}
          </div>
        </div>
        <hr />
        <Dialog
          visible={this.state.inModalMode}
          style={{ width: this.state.modalWidth }}
          onHide={(e) => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={
            <h5 className="modal-header">
              {this.state.inEditMode
                ? this.state.modalHeaderEdit
                : this.state.modalHeaderAdd}
            </h5>
          }
          footer={
            <div>
              <Button
                label={
                  this.state.inEditMode
                    ? this.state.modalSubmitButtonLabelEdit
                    : this.state.modalSubmitButtonLabelAdd
                }
                icon={
                  this.state.inEditMode
                    ? this.state.modalSubmitButtonIconEdit
                    : this.state.modalSubmitButtonIconAdd
                }
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doSubmit()}
              />
              <Button
                label="Cancel"
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={this.state.inEditMode}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              {
                type: "text",
                id: "title",
                label: "Title",
                disabled: false,
              },
              {
                type: "dropdown",
                id: "clientId",
                label: "Client",
                options: this.state.allClients,
                disabled: false,
              },
              {
                type: "dropdown",
                id: "typeId",
                label: "Type",
                options: this.state.allTypes,
                disabled: false,
              },
              {
                type: "datetime",
                id: "startDate",
                label: "Start Date",
                disabled: false,
              },
              {
                type: "datetime",
                id: "endDate",
                label: "End Date",
                disabled: false,
              },
              {
                type: "text",
                id: "details",
                label: "Details",
                disabled: false,
              },
            ]}
          />
        </Dialog>
        <GridTable
          columns={this.state.tableColumns}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 30, 40]}
          texts={{
            search: "Search:",
            totalRows: "Total Rows:",
            rows: "Row:",
            selected: "Selected",
            rowsPerPage: "Rows Per Page:",
            page: "Page:",
            of: "of",
            prev: "Pervious",
            next: "Next",
            columnVisibility: "Column Visibility",
          }}
        />
      </div>
    );
  }
}

export default SuppotServices;
